import ExitWarningModal from './ExitWarningModal';

export default ExitWarningModal;
